import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PhoneInput from '../../../../../components/global/PhoneInput';
import FormGroup from '../../../../../components/global/FormGroup';
import Label from '../../../../../components/global/Label';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import AuthLegalDisclosure from '../../../../../components/auth/AuthLegalDisclosure';
import { getFormikTouchedErrors } from '../../../../../util/formik';
import CustomControl from '../../../../../components/global/CustomControl';

const propTypes = {
  loading: PropTypes.bool,
  values: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone_number: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onUseEmailRegistration: PropTypes.func.isRequired,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const UserInformationStep = ({
  loading,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  identityName,
  onUseEmailRegistration,
  requireHumanInput,
  blockLogin,
}) => {
  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );

  return (
    <Fragment>
      <h4 className="px-2 mb-4">
        Welcome to Waldo! <br /> Please confirm your identity below to view
        photos{identityName ? ` of ${identityName}` : ''}.
      </h4>
      <form onSubmit={handleSubmit} className="px-2">
        <div className="row">
          <div className="col-lg-6 col-12">
            <FormGroup
              id="first_name"
              name="first_name"
              label="First name"
              placeholder="John"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.first_name}
              required
            />
          </div>

          <div className="col-lg-6 col-12">
            <FormGroup
              id="last_name"
              name="last_name"
              label="Last name"
              placeholder="Smith"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.last_name}
              required
            />
          </div>

          <div className="col-12">
            <Label id="phone_number">Phone number</Label>
            <PhoneInput
              id="phone_number"
              value={values.phone_number || '+1'}
              onChange={phone => {
                handleChange({
                  target: {
                    name: 'phone_number',
                    value: phone,
                  },
                });
              }}
              className="mb-2"
              required
            />
          </div>
          {requireHumanInput && (
            <div className="col-12 mb-2">
              <CustomControl
                type="checkbox"
                label="I'm not a robot"
                checked={values.force_allow_action}
                onChange={() =>
                  handleChange({
                    target: {
                      name: 'force_allow_action',
                      value: !values.force_allow_action,
                    },
                  })
                }
              />
            </div>
          )}
        </div>

        {errorList?.length > 0 && (
          <Alert type="danger" className="mb-4">
            <ul className="mb-0">
              {errorList.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        )}

        <Button
          type="submit"
          disabled={
            loading ||
            (values.phone_number === '+1' && !values.email_address) ||
            blockLogin ||
            (requireHumanInput && !values.force_allow_action)
          }
          loading={loading}
        >
          {loading ? 'Processing...' : 'Send PIN Code to Verify'}
        </Button>
        {onUseEmailRegistration && (
          <div className="mt-3">
            Can&apos;t receive an SMS?&nbsp;
            <Button
              btnStyle="link"
              onClick={e => {
                e.preventDefault();
                onUseEmailRegistration();
              }}
            >
              Register with email
            </Button>
          </div>
        )}

        <AuthLegalDisclosure
          className="mt-4"
          showSmsConsent
          smsCtaLabel="Send PIN Code to Verify"
        />
      </form>
    </Fragment>
  );
};

UserInformationStep.propTypes = propTypes;

export default UserInformationStep;
